export { default } from './Collective';
